import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { getStyledText } from '../../helpers/styled';
import SelectorBody from './SelectorBody';
export var SelectorWrapper = styled.div.withConfig({
  displayName: "style__SelectorWrapper",
  componentId: "sc-fqjb1t-0"
})(["border:", ";height:", ";"], function (p) {
  return !p.selected && '1px solid transparent';
}, function (p) {
  return p.autoHeight ? 'auto' : '100%';
});
export var SelectContainer = withTheme(styled.div.withConfig({
  displayName: "style__SelectContainer",
  componentId: "sc-fqjb1t-1"
})(["box-sizing:border-box;border:", ";border-radius:", ";width:100%;height:100%;padding:", ";background-color:", ";pointer-events:default;display:flex;flex-direction:", ";align-items:center;justify-content:", ";", ";"], function (props) {
  var _props$coreTheme$sele, _props$coreTheme$sele2;

  return props.selected ? ((_props$coreTheme$sele = props.coreTheme.selector) === null || _props$coreTheme$sele === void 0 ? void 0 : _props$coreTheme$sele.selectedBorder) || "2px solid ".concat(props.coreTheme.cl_sec_d1) : ((_props$coreTheme$sele2 = props.coreTheme.selector) === null || _props$coreTheme$sele2 === void 0 ? void 0 : _props$coreTheme$sele2.border) || "1px solid ".concat(props.coreTheme.cl_ter_l4);
}, function (props) {
  var _props$coreTheme$sele3;

  return ((_props$coreTheme$sele3 = props.coreTheme.selector) === null || _props$coreTheme$sele3 === void 0 ? void 0 : _props$coreTheme$sele3.borderRadius) || '8px';
}, function (props) {
  var _props$coreTheme$sele4;

  return props.noPadding ? '0' : ((_props$coreTheme$sele4 = props.coreTheme.selector) === null || _props$coreTheme$sele4 === void 0 ? void 0 : _props$coreTheme$sele4.padding) || (props.altPadding ? '16px 8px' : '24px');
}, function (props) {
  return props.coreTheme.cl_white;
}, function (props) {
  return props.alignment;
}, function (props) {
  return props.justifyContent || 'space-between';
}, function (props) {
  var _props$coreTheme$sele5, _props$coreTheme$sele6;

  return props.disabled && "opacity: ".concat(((_props$coreTheme$sele5 = props.coreTheme.selector) === null || _props$coreTheme$sele5 === void 0 ? void 0 : _props$coreTheme$sele5.disabledOpacity) || 0.5, ";\n    background: ").concat(((_props$coreTheme$sele6 = props.coreTheme.selector) === null || _props$coreTheme$sele6 === void 0 ? void 0 : _props$coreTheme$sele6.disabledColor) || props.coreTheme.cl_white, ";\n    pointer-events: none;\n  ");
}));
export var Image = withTheme(styled.img.withConfig({
  displayName: "style__Image",
  componentId: "sc-fqjb1t-2"
})(["height:auto;width:", ";"], function (p) {
  return p.width ? p.width : '48px';
}));
export var Body = withTheme(styled.div.withConfig({
  displayName: "style__Body",
  componentId: "sc-fqjb1t-3"
})(["display:flex;flex-direction:column;align-items:", ";justify-content:center;"], function (p) {
  return p.align === 'start' ? 'flex-start' : p.align === 'end' ? 'flex-end' : 'center';
}));
export var EndContent = styled(SelectorBody).withConfig({
  displayName: "style__EndContent",
  componentId: "sc-fqjb1t-4"
})(["", ""], function (_ref) {
  var alignment = _ref.alignment;

  switch (alignment) {
    case 'column':
      return css(["margin-top:24px;"]);

    case 'column-reverse':
      return css(["margin-bottom:24px;"]);

    case 'row-reverse':
      return css(["align-self:flex-start;margin-right:24px;"]);

    default:
      return css(["align-self:flex-start;margin-left:24px;"]);
  }
});
export var BodyTitle = withTheme(getStyledText('body')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.disabled ? p.coreTheme.cl_ter_l4 : p.coreTheme.cl_ter_base;
}));
export var BodySubtitle = withTheme(getStyledText('smallBody')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.disabled ? p.coreTheme.cl_ter_l4 : p.coreTheme.cl_ter_base;
}));
export var OuterCircle = withTheme(styled.div.withConfig({
  displayName: "style__OuterCircle",
  componentId: "sc-fqjb1t-5"
})(["display:flex;align-items:center;justify-content:center;position:relative;height:38px;width:38px;border-radius:50%;text-align:center;border:", ";"], function (p) {
  return "1px solid ".concat(p.coreTheme.cl_ter_l4);
}));
export var InnerCircle = withTheme(styled.div.withConfig({
  displayName: "style__InnerCircle",
  componentId: "sc-fqjb1t-6"
})(["height:30px;width:30px;border-radius:50%;background-color:", ";border:", ";box-sizing:content-box;"], function (p) {
  return p.hexCode;
}, function (p) {
  return "1px solid ".concat(p.coreTheme.cl_ter_l5);
}));
export var Slash = withTheme(styled.div.withConfig({
  displayName: "style__Slash",
  componentId: "sc-fqjb1t-7"
})(["border-bottom:", ";border-radius:0;width:32px;transform:rotate(-45deg);height:14px;transform-origin:50% 100%;"], function (p) {
  return p.filledColor === p.coreTheme.cl_white ? "2px solid ".concat(p.coreTheme.cl_ter_l5) : "2px solid ".concat(p.coreTheme.cl_white);
}));